var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovaLogoInverted = function SvgNovaLogoInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1FF66",
    d: "m8.295.29 1.479 6.426c.04.167.164.3.329.346l5.496 1.499c.364.099.364.624 0 .724l-5.496 1.498a.46.46 0 0 0-.329.346l-1.48 6.427c-.087.386-.63.386-.717 0l-1.48-6.427a.47.47 0 0 0-.328-.346L.273 9.285c-.364-.1-.364-.625 0-.724l5.496-1.499a.46.46 0 0 0 .329-.346L7.577.29c.088-.385.63-.385.718 0"
  })));
};
export default SvgNovaLogoInverted;